const tableData = [
    {
        app_id: '194940',
        name: 'sleman',
        app_token: 'd28wqk9wpj4c1510pc2hkbh1dubynw6ig8z24hqp0np8k9rwsyjizx18ibpxk2pt'
    },
    {
        app_id: '194452',
        name: 'army',
        app_token: 'd28wqk9wpj4c1510pc2hkbh1dubynw6ig8z24hqp0np8k9rwsyjizx18ibpxk2pt'
   },
     
];

export { tableData };
